import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Nullable } from "../../pojo/Util";

@TypeManagerDecorator("s25-ng-loading-inline-static")
@Component({
    selector: "s25-ng-loading-inline-static",
    template: `
        <svg class="c-loading" x="0px" y="0px" viewBox="0 0 150 150">
            <circle class="c-loading__inner" cx="75" cy="75" r="60" />
        </svg>
        @if (!!text) {
            <span class="s25-text">{{ text }}</span>
        }
    `,
    styles: `
        :host {
            display: block;
        }

        span {
            margin-left: 0.5em;
            margin-block: auto;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class S25LoadingInlineStaticComponent {
    @Input() text: Nullable<string> = "Loading...";
}
